(() => {
    'use strict';

    const getCart = async () => {
        const res = await fetch('/cart.js');
        if (!res.ok) throw new Error('Could not fetch cart data.');
        return res.json();
    };

    const applyDiscount = async (code) => {
        const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code }),
        });
        const cart = await res.json();
        if (!res.ok) throw new Error(cart.description || 'Invalid discount code');
        return cart;
    };

    const checkDiscountValidity = async (code) => {
        // Use Shopify's discount code validation endpoint
        const response = await fetch(`/discount/${code}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });

        return {
            isValid: response.ok,
            error: response.ok ? null : 'Invalid discount code'
        };
    };


    // Check for applied coupons that should trigger gift card addition


    // --- Global updateUI function ---
    const updateUI = (cartData = null) => {
        // Select the container where tags will be displayed
        const tagsContainer = document.querySelector('.discount-tags-container');
        if (!tagsContainer) return;

        // Use provided cart data or fetch if not available
        const processCart = (cart) => {
                // Show only valid coupons (applicable: true)
                if (cart.discount_codes && cart.discount_codes.length > 0) {
                    const validCodes = cart.discount_codes.filter(dc => dc.applicable);
                    const uniqueCodes = Array.from(new Set(validCodes.map(dc => dc.code)));
                    
                    // Check if current tags match the new codes to avoid unnecessary updates
                    const currentTags = Array.from(tagsContainer.querySelectorAll('.discount-tag span')).map(span => span.textContent);
                    const codesChanged = JSON.stringify(currentTags.sort()) !== JSON.stringify(uniqueCodes.sort());
                    
                    if (codesChanged) {
                        // Only update if codes have actually changed
                        tagsContainer.innerHTML = '';
                        uniqueCodes.forEach(code => {
                            const tag = document.createElement('div');
                            tag.className = 'discount-tag';
                            tag.innerHTML = `
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.70235 12.5111C5.55207 12.5111 5.40179 12.4811 5.25151 12.421C5.10124 12.3608 4.96598 12.2707 4.84576 12.1505L0.54779 7.85249C0.427567 7.73226 0.339904 7.59952 0.284802 7.45425C0.2297 7.30898 0.202148 7.16121 0.202148 7.01093C0.202148 6.86065 0.2297 6.71037 0.284802 6.56009C0.339904 6.40981 0.427567 6.27456 0.54779 6.15434L5.8376 0.849499C5.94781 0.739295 6.07805 0.651633 6.22833 0.586512C6.3786 0.521391 6.53389 0.488831 6.69419 0.488831H11.0072C11.3378 0.488831 11.6208 0.606549 11.8563 0.841986C12.0917 1.07742 12.2094 1.36045 12.2094 1.69106V6.00406C12.2094 6.16436 12.1794 6.31714 12.1193 6.46241C12.0591 6.60768 11.974 6.73542 11.8638 6.84562L6.55894 12.1505C6.43872 12.2707 6.30347 12.3608 6.15319 12.421C6.00291 12.4811 5.85263 12.5111 5.70235 12.5111ZM5.70235 11.3089L11.0072 5.98903V1.69106H6.70922L1.40438 7.01093L5.70235 11.3089ZM9.5044 4.09552C9.75487 4.09552 9.96776 4.00786 10.1431 3.83253C10.3184 3.65721 10.4061 3.44431 10.4061 3.19385C10.4061 2.94338 10.3184 2.73049 10.1431 2.55516C9.96776 2.37984 9.75487 2.29218 9.5044 2.29218C9.25394 2.29218 9.04104 2.37984 8.86572 2.55516C8.69039 2.73049 8.60273 2.94338 8.60273 3.19385C8.60273 3.44431 8.69039 3.65721 8.86572 3.83253C9.04104 4.00786 9.25394 4.09552 9.5044 4.09552Z" fill="#1C1B1F"/>
                                </svg>
                                <span>${code}</span>
                                <button class="discount-tag-remove" title="Remove coupon" style="margin-left:6px;cursor:pointer;background:none;border:none;font-size:16px;"> 
                                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.21253 11L0 9.78747L4.30172 5.48575L0 1.21253L1.21253 0L5.51425 4.30172L9.78747 0L11 1.21253L6.69828 5.48575L11 9.78747L9.78747 11L5.51425 6.69828L1.21253 11Z" fill="#1C1B1F"/>
                                    </svg>
                                </button>
                            `;
                            tag.querySelector('.discount-tag-remove').addEventListener('click', handleRemove);
                            tagsContainer.appendChild(tag);
                        });
                    }
                } else {
                    // Clear tags only if there are currently tags to clear
                    if (tagsContainer.children.length > 0) {
                        tagsContainer.innerHTML = '';
                    }
                }
                
                // Show or hide container based on whether there are tags
                const tagsCount = tagsContainer.children.length;
                tagsContainer.style.display = tagsCount > 0 ? 'block' : 'none';

                // --- Show original subtotal, discounted subtotal and Discount Applied ---
                let couponCode = null;
                if (cart.discount_codes && cart.discount_codes.length > 0) {
                    // Use only the first valid code
                    const validCodes = cart.discount_codes.filter(dc => dc.applicable);
                    if (validCodes.length > 0) {
                        couponCode = validCodes[0].code;
                    }
                }
                let totalDiscountAmount = 0;
                if (couponCode) {
                    cart.items.forEach(item => {
                        if (item.discounts && item.discounts.length > 0) {
                            item.discounts.forEach(d => {
                                if (d.title.toLowerCase() === couponCode.toLowerCase()) {
                                    totalDiscountAmount += d.amount;
                                }
                            });
                        }
                    });
                }
                if (window.location.href !== 'https://lolablankets.com/cart') {
                    const subtotalContainer = document.querySelector('.cart__details .cart__detail-info [data-cart-subtotal]');
                    if (subtotalContainer) {
                        const currency = cart.currency || 'USD';
                        const lang = document.documentElement.lang || 'en';
                        const format = v => new Intl.NumberFormat(lang, { style: 'currency', currency }).format(v / 100);
                        const originalSubtotal = format(cart.total_price + totalDiscountAmount);
                        const discountedSubtotal = format(cart.total_price);
                        if (totalDiscountAmount > 0) {
                            subtotalContainer.innerHTML = `<s style="color:#808080;margin-right:16px">${originalSubtotal}</s> <span style="font-weight:bold;color:#222;">${discountedSubtotal}</span>`;
                        } else {
                            subtotalContainer.innerHTML = `<span style="font-weight:bold;color:#222;">${discountedSubtotal}</span>`;
                        }
                    }
                }
                // Discount Applied div
                let discountAppliedContainer = document.querySelector('.discount-applied-container');
                if (!discountAppliedContainer) {
                    discountAppliedContainer = document.createElement('div');
                    discountAppliedContainer.className = 'discount-applied-container';
                    discountAppliedContainer.style.display = 'none';
                    const cartDetails = document.querySelector('.cart__details');
                    if (cartDetails) {
                        cartDetails.appendChild(discountAppliedContainer);
                    }
                }
                if (totalDiscountAmount > 0) {
                    const currency = cart.currency || 'USD';
                    const lang = document.documentElement.lang || 'en';
                    const format = v => new Intl.NumberFormat(lang, { style: 'currency', currency }).format(v / 100);
                    discountAppliedContainer.style.display = 'flex';
                    discountAppliedContainer.innerHTML = `<span>Discount Applied:</span> <span>-${format(totalDiscountAmount)}</span>`;
                } else {
                    discountAppliedContainer.style.display = 'none';
                }
            };

        // If cart data is provided, use it directly; otherwise fetch
        if (cartData) {
            processCart(cartData);
        } else {
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    processCart(cart);
                })
                .catch(e => {
                    console.error('Error getting cart', e);
                });
        }
    };

    // --- Debounced updateUI to prevent flickering ---
    let updateUITimeout;
    let lastCartState = null;
    
    const debouncedUpdateUI = () => {
        clearTimeout(updateUITimeout);
        updateUITimeout = setTimeout(async () => {
            // Check if cart state has actually changed
            try {
                const currentCart = await getCart();
                const currentState = JSON.stringify({
                    discount_codes: currentCart.discount_codes,
                    item_count: currentCart.item_count,
                    total_discount: currentCart.total_discount
                });
                
                if (lastCartState !== currentState) {
                    lastCartState = currentState;
                    updateUI(currentCart);
                } else {
                    console.log('Cart state unchanged, skipping UI update');
                }
            } catch (error) {
                // If we can't check, update anyway
                updateUI();
            }
        }, 200); // Increased delay to reduce flickering
    };
    
    // --- Global handleRemove function ---
    const handleRemove = async (event) => {
        if (event.currentTarget.disabled) return;

        event.currentTarget.disabled = true;
        const discountTag = event.currentTarget.closest('.discount-tag');
        discountTag.style.pointerEvents = 'none';
        discountTag.style.opacity = '0.5';

        document.body.style.cursor = 'wait';
        try {
            const cartBefore = await getCart();
            await applyDiscount(''); // Remove discount
            const cartAfter = await getCart();

            if (cartAfter.total_discount < cartBefore.total_discount) {
                // Check if the removed coupon is in show_promo and remove gift card if needed
                if (typeof show_promo !== 'undefined') {
                    const codes = show_promo.split('|').map(c => c.toLowerCase());
                    const discountTagText = discountTag.querySelector('span').textContent;
                    if (codes.includes(discountTagText.toLowerCase())) {
                        const giftCardVariantId = 52349316890996;
                        const giftCardItem = cartAfter.items.find(item => item.variant_id === giftCardVariantId);

                        if (giftCardItem) {
                            // Remove gift card without delay
                            const response = await fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    id: giftCardItem.key,
                                    quantity: 0
                                })
                            });
                            
                            if (response.ok) {
                                const data = await response.json();
                                
                                // Update UI immediately without page reload
                                if (typeof theme !== 'undefined' && theme.refreshCart) {
                                    theme.refreshCart();
                                }
                                
                                // Trigger cart update event
                                $('body').trigger('updateCart', data);
                                
                                // Update cart count
                                const cartCountElement = document.querySelector('.cart-link__count');
                                if (cartCountElement) {
                                    cartCountElement.textContent = data.item_count;
                                }
                            }
                        }
                    }
                }

                // Update UI instead of reloading page
                debouncedUpdateUI();
                
                // Force cart state cleanup to prevent 400 errors when changing quantities
                setTimeout(() => {
                    fetch('/cart.js')
                        .then(res => res.json())
                        .then(cart => {
                            // Trigger cart update to ensure consistency
                            $('body').trigger('updateCart', cart);
                            
                            // Force theme cart rebuild if available
                            if (typeof theme !== 'undefined' && theme.cart && theme.cart.buildCart) {
                                theme.cart.buildCart(cart);
                            }
                            
                        })
                        .catch(error => {
                            console.error('Error cleaning cart state:', error);
                        });
                }, 300);
                
                // Show success message
                const messageElement = document.querySelector('.discount-message');
                if (messageElement) {
                    messageElement.textContent = 'Coupon removed successfully!';
                    messageElement.className = 'discount-message success';
                    setTimeout(() => {
                        messageElement.textContent = '';
                    }, 3000);
                }
            }
        } catch (error) {
            console.error('Error removing discount:', error);
            event.currentTarget.disabled = false;
            discountTag.style.pointerEvents = 'auto';
            discountTag.style.opacity = '1';
            document.body.style.cursor = 'default';
        } finally {
            document.body.style.cursor = 'default';
        }
    };

    // --- Main Initialization for a single field ---
    const initializeDiscountField = (insertionPoint) => {
        if (insertionPoint.dataset.initialized === 'true') return;
        insertionPoint.dataset.initialized = 'true';

        const placeholderText = 'Discount Code';
        const buttonText = 'Apply';

        insertionPoint.innerHTML = `
        <div class="discount-field-container">
        <div class="discount-field-content">
          <div class="discount-input-wrapper">
            <input type="text" name="discount" class="discount-input" placeholder="${placeholderText}">
            <button type="button" class="discount-button">${buttonText}</button>
          </div>
          <div class="discount-tags-container" style="display:none;"></div>
          <div class="discount-message"></div>
          <div class="discount-applied-container" style="display:none;"></div>
        </div>
        </div>`;

        const DOMElements = {
            input: insertionPoint.querySelector('.discount-input'),
            applyBtn: insertionPoint.querySelector('.discount-button'),
            messageDiv: insertionPoint.querySelector('.discount-message'),
            tagsContainer: insertionPoint.querySelector('.discount-tags-container'),
            inputWrapper: insertionPoint.querySelector('.discount-input-wrapper'),
            appliedContainer: insertionPoint.querySelector('.discount-applied-container'),
        };

        let isProcessing = false;

        const showMessage = (msg, type = 'error', timeout = 5000) => {
            DOMElements.messageDiv.innerHTML = msg;
            DOMElements.messageDiv.className = `discount-message ${type}`;
            if (msg) setTimeout(() => { DOMElements.messageDiv.textContent = '' }, timeout);
        };

        const restoreButtonState = (clearInput = false) => {
            isProcessing = false;
            DOMElements.applyBtn.disabled = false;
            DOMElements.applyBtn.textContent = buttonText;
            
            if (clearInput) {
                DOMElements.input.value = '';
                DOMElements.input.focus();
            }
        };

        const handleApply = async () => {
            if (isProcessing) return;
            const code = DOMElements.input.value.trim();
            if (!code) { showMessage('Please enter a coupon code.'); return; }

            isProcessing = true;
            DOMElements.applyBtn.disabled = true;
            DOMElements.applyBtn.textContent = 'Checking...';

            try {
                // Get cart before applying discount to compare
                const cartBefore = await getCart();

                // Get the active coupon from the cart
                const cart = await getCart();
                let activeCoupon = null;
                if (cart.discount_codes && cart.discount_codes.length > 0) {
                    const validCodes = cart.discount_codes.filter(dc => dc.applicable);
                    if (validCodes.length > 0) {
                        activeCoupon = validCodes[0].code;
                    }
                }

                // Check if the discount code is valid first
                const validation = await checkDiscountValidity(code);

                if (!validation.isValid) {
                    showMessage(validation.error);
                    // Restore button state when coupon is invalid (don't clear input)
                    restoreButtonState(false);
                    return;
                }

                DOMElements.applyBtn.textContent = 'Applying...';

                // If valid, apply the discount
                const cartAfter = await applyDiscount(code);
                const codes = show_promo.split('|').map(c => c.toLowerCase());
                
                // Check if discount was actually applied by comparing total_discount
                if (cartAfter.total_discount > cartBefore.total_discount) {
                    // Discount was successfully applied
                    if (codes.includes(code.toLowerCase())) {
                        // Add gift card automatically for show_promo coupons
                        const giftCardVariantId = 52349316890996;
                        const available = await isGiftCardAvailable(giftCardVariantId);
                        if (available) {
                            fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    items: [{
                                        id: giftCardVariantId,
                                        quantity: 1
                                    }]
                                })
                            })
                                .then(response => response.json())
                                .then(data => {
                                    // Use theme's native cart refresh function
                                    if (typeof theme !== 'undefined' && theme.refreshCart) {
                                        theme.refreshCart();
                                    }

                                    // Trigger the updateCart event that the theme listens to
                                    $('body').trigger('updateCart', data);

                                    // Update cart count manually
                                    const cartCountElement = document.querySelector('.cart-link__count');
                                    if (cartCountElement) {
                                        cartCountElement.textContent = data.item_count;
                                    }

                                    showMessage('Coupon applied and gift card added successfully!', 'success');
                                    restoreButtonState(true);

                                })
                                .catch(error => {
                                    console.error('Error adding gift card:', error);
                                    showMessage('Coupon applied successfully!', 'success');
                                    // Restore button state even if gift card fails (clear input)
                                    restoreButtonState(true);
                                });
                        } else {
                            console.warn('Gift card product is not available or is in draft.');
                            showMessage('Coupon applied successfully!', 'success');
                            // Restore button state when gift card is not available (clear input)
                            restoreButtonState(true);
                        }
                    } else {
                        showMessage('Coupon applied successfully!', 'success');
                    }

                    // Update UI
                    debouncedUpdateUI();
                    
                    // Force cart state cleanup to prevent 400 errors when changing quantities
                    setTimeout(() => {
                        fetch('/cart.js')
                            .then(res => res.json())
                            .then(cart => {
                                // Trigger cart update to ensure consistency
                                $('body').trigger('updateCart', cart);
                                
                                // Force theme cart rebuild if available
                                if (typeof theme !== 'undefined' && theme.cart && theme.cart.buildCart) {
                                    theme.cart.buildCart(cart);
                                }
                            })
                            .catch(error => {
                                console.error('Error cleaning cart state:', error);
                            });
                    }, 300);
                    
                    // Restore button state when coupon is successfully applied (clear input)
                    restoreButtonState(true);

                } else {
                    await applyDiscount(activeCoupon)
                    showMessage('Coupon invalid');
                    // Restore button state when coupon is invalid (don't clear input)
                    restoreButtonState(false);
                }
            } catch (error) {
                showMessage('Coupon invalid');
                // Restore button state when coupon is invalid (don't clear input)
                restoreButtonState(false);
            }
        };

        const handleRemove = async (event) => {
            if (isProcessing) return;
            isProcessing = true;
            const removeButton = event.currentTarget;
            const discountTag = removeButton.closest('.discount-tag');

            removeButton.disabled = true;
            discountTag.style.pointerEvents = 'none';
            discountTag.style.opacity = '0.5';

            document.body.style.cursor = 'wait';
            try {
                // Get cart before removing discount to compare
                const cartBefore = await getCart();

                // Get the coupon code that is being removed
                const couponCodeElement = removeButton.closest('.discount-tag').querySelector('span');
                const couponCodeToRemove = couponCodeElement ? couponCodeElement.textContent.trim() : '';

                await applyDiscount(''); // Removing is applying an empty code

                // Check if discount was actually removed
                const cartAfter = await getCart();

                if (cartAfter.total_discount < cartBefore.total_discount) {
                    // Check if the removed coupon is in show_promo and remove gift card if needed
                    const codes = show_promo.split('|').map(c => c.toLowerCase());
                    if (codes.includes(couponCodeToRemove.toLowerCase())) {
                        // Remove gift card from cart if the removed coupon was in show_promo
                        const giftCardVariantId = 52349316890996;
                        const giftCardItem = cartAfter.items.find(item => item.variant_id === giftCardVariantId);

                        if (giftCardItem) {
                            // Remove gift card
                            const response = await fetch('/cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    id: giftCardItem.key,
                                    quantity: 0
                                })
                            });
                            
                            if (response.ok) {
                                const data = await response.json();
                                // Update UI immediately without page reload
                                if (typeof theme !== 'undefined' && theme.refreshCart) {
                                    theme.refreshCart();
                                }

                                // Trigger the updateCart event that the theme listens to
                                $('body').trigger('updateCart', data);

                                // Update cart count manually
                                const cartCountElement = document.querySelector('.cart-link__count');
                                if (cartCountElement) {
                                    cartCountElement.textContent = data.item_count;
                                }
                            }
                        }


                    }

                    showMessage('Coupon removed successfully!', 'success');
                    
                    // Update UI instead of reloading page
                    debouncedUpdateUI();
                } else {
                    showMessage('Could not remove discount.');
                    removeButton.disabled = false;
                    discountTag.style.pointerEvents = 'auto';
                    discountTag.style.opacity = '1';
                    isProcessing = false;
                    document.body.style.cursor = 'default';
                }

            } catch (error) {
                showMessage('Could not remove discount.');
                removeButton.disabled = false;
                discountTag.style.pointerEvents = 'auto';
                discountTag.style.opacity = '1';
                isProcessing = false;
                document.body.style.cursor = 'default';
            }
        };



        DOMElements.applyBtn.addEventListener('click', handleApply);
        DOMElements.input.addEventListener('keypress', (e) => e.key === 'Enter' && (e.preventDefault(), handleApply()));

        // Run the UI update on initialization. It's synchronous.
        debouncedUpdateUI();
    };

    // --- Main Execution Logic ---
    const run = () => {
        // --- Check for applied coupons and add gift card if needed ---
        const checkAndAddGiftCardForAppliedCoupons = async () => {
            let updatedCart; 
            try {
                const cart = await getCart();
                updatedCart = cart; 
                const giftCardVariantId = 52349316890996;
                const hasGiftCard = cart.items.some(item => item.variant_id === giftCardVariantId);
                
                // Check if there are any applied discount codes
                if (cart.discount_codes && cart.discount_codes.length > 0) {
                    const codes = show_promo.split('|').map(c => c.toLowerCase());
                    let hasShowPromoCoupon = false;
                    
                    // Check each applied discount code
                    for (const discountCode of cart.discount_codes) {
                        if (codes.includes(discountCode.code.toLowerCase())) {
                            // Only consider valid (applicable) show_promo coupons
                            if (discountCode.applicable) {
                                hasShowPromoCoupon = true;
                                // This coupon is in show_promo and is valid, check if gift card should be added
                                
                                if (!hasGiftCard && cart.items.length > 0) {
                                    const available = await isGiftCardAvailable(giftCardVariantId);
                                    if (available) {
                                        // Add gift card automatically
                                        fetch('/cart/add.js', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                            },
                                            body: JSON.stringify({
                                                items: [{
                                                    id: giftCardVariantId,
                                                    quantity: 1
                                                }]
                                            })
                                        })
                                        .then(response => response.json())
                                        .then(data => {
                                            updatedCart = data;
                                            // Use theme's native cart refresh function
                                            if (typeof theme !== 'undefined' && theme.refreshCart) {
                                                theme.refreshCart();
                                            }
                                            
                                            // Trigger the updateCart event that the theme listens to
                                            $('body').trigger('updateCart', data);
                                            
                                            // Update cart count manually
                                            const cartCountElement = document.querySelector('.cart-link__count');
                                            if (cartCountElement) {
                                                cartCountElement.textContent = data.item_count;
                                            }
                                            
                                        })
                                        .catch(error => {
                                            console.error('Error adding gift card automatically:', error);
                                        });
                                    } else {
                                        console.warn('Gift card product is not available or is in draft.');
                                    }
                                }
                                break; // Only need to check one coupon
                            }
                        }
                    }
                    
                    // If no valid show_promo coupon is applied but gift card is present, remove it
                    if (!hasShowPromoCoupon && hasGiftCard) {
                        const giftCardItem = cart.items.find(item => item.variant_id === giftCardVariantId);
                        if (giftCardItem) {
                            fetch('/cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    id: giftCardItem.key,
                                    quantity: 0
                                })
                            })
                            .then(response => response.json())
                            .then(data => {
                                updatedCart = data;
                                // Use theme's native cart refresh function
                                if (typeof theme !== 'undefined' && theme.refreshCart) {
                                    theme.refreshCart();
                                }
                                
                                // Trigger the updateCart event that the theme listens to
                                $('body').trigger('updateCart', data);
                                
                                // Update cart count manually
                                const cartCountElement = document.querySelector('.cart-link__count');
                                if (cartCountElement) {
                                    cartCountElement.textContent = data.item_count;
                                }
                                
                                console.log('Gift card removed successfully');
                                
                            })
                            .catch(error => {
                                console.error('Error removing gift card:', error);
                            });
                        }
                    }
                } else {
                    // No discount codes applied, remove gift card if present
                    if (hasGiftCard) {
                        console.log('No discount codes applied, removing gift card...');
                        const giftCardItem = cart.items.find(item => item.variant_id === giftCardVariantId);
                        if (giftCardItem) {
                            fetch('/cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    id: giftCardItem.key,
                                    quantity: 0
                                })
                            })
                            .then(response => response.json())
                            .then(data => {
                                updatedCart = data;
                                // Use theme's native cart refresh function
                                if (typeof theme !== 'undefined' && theme.refreshCart) {
                                    theme.refreshCart();
                                }
                                
                                // Trigger the updateCart event that the theme listens to
                                $('body').trigger('updateCart', data);
                                
                                // Update cart count manually
                                const cartCountElement = document.querySelector('.cart-link__count');
                                if (cartCountElement) {
                                    cartCountElement.textContent = data.item_count;
                                }
                                
                                console.log('Gift card removed successfully');
                                
                            })
                            .catch(error => {
                                console.error('Error removing gift card:', error);
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Error checking applied coupons for gift card:', error);
                // If there's an error, return the original cart
                updatedCart = cart;
            }
            
            return updatedCart;
        };
        
        // Execute the check when page loads
        checkAndAddGiftCardForAppliedCoupons();

        // --- Reopen the cart drawer if necessary ---
        if (sessionStorage.getItem('reopenCartDrawer')) {

            const cartButton = document.querySelector('.js-drawer-open-cart');
            if (cartButton) {
                setTimeout(() => {
                    cartButton.click();
                    sessionStorage.removeItem('reopenCartDrawer');
                }, 2500);
            }
        }

        document.querySelectorAll('.discount-field-insertion-point').forEach(initializeDiscountField);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });

   

    // --- Listen for cart updates and call updateDiscountTagsContainer ---
    document.addEventListener('cart:updated', () => {
        setTimeout(() => {
            debouncedUpdateUI();
        }, 500); // Small delay to ensure cart data is updated
    });

    // --- Listen for page visibility changes (when user returns from checkout) ---
    let visibilityUpdateTimeout;
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            // Clear any pending timeout to prevent multiple executions
            if (visibilityUpdateTimeout) {
                clearTimeout(visibilityUpdateTimeout);
            }
            
            // User returned to the page (possibly from checkout)
            visibilityUpdateTimeout = setTimeout(async () => {
                console.log('Page became visible - checking cart state...');
                // Check gift cards and get updated cart data
                const updatedCart = await checkAndAddGiftCardForAppliedCoupons();
                // Force immediate UI update with updated cart data to sync coupon interface
                updateUI(updatedCart);
            }, 200); // Reduced from 1000ms to 200ms for faster response
        }
    });

    // --- Listen for focus events (when user returns to tab) ---
    let focusUpdateTimeout;
    window.addEventListener('focus', () => {
        // Clear any pending timeout to prevent multiple executions
        if (focusUpdateTimeout) {
            clearTimeout(focusUpdateTimeout);
        }
        
        focusUpdateTimeout = setTimeout(async () => {
            console.log('Window focused - checking cart state...');
            // Check gift cards and get updated cart data
            const updatedCart = await checkAndAddGiftCardForAppliedCoupons();
            // Force immediate UI update with updated cart data to sync coupon interface
            updateUI(updatedCart);
        }, 100); // Reduced from 500ms to 100ms for faster response
    });

    // --- Make updateUI globally accessible for console debugging ---
    window.updateUI = updateUI;
    
    // --- Function to clean cart state and prevent 400 errors ---
    const cleanCartState = () => {
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
                // Trigger cart update to ensure consistency
                $('body').trigger('updateCart', cart);
                
                // Force theme cart rebuild if available
                if (typeof theme !== 'undefined' && theme.cart && theme.cart.buildCart) {
                    theme.cart.buildCart(cart);
                }
                
                // Update UI with debouncing to prevent flickering
                debouncedUpdateUI();
            })
            .catch(error => {
                console.error('Error cleaning cart state:', error);
            });
    };
    
    // Make it globally accessible
    window.cleanCartState = cleanCartState;
    
    // --- Function to force complete UI update (gift cards + discount section) ---
    let completeUIUpdateTimeout;
    const forceCompleteUIUpdate = async () => {
        // Prevent multiple simultaneous executions
        if (completeUIUpdateTimeout) {
            clearTimeout(completeUIUpdateTimeout);
        }
        
        completeUIUpdateTimeout = setTimeout(async () => {
            console.log('Forcing complete UI update...');
            
            try {
                // First, check and clean gift cards
                await checkAndAddGiftCardForAppliedCoupons();
                
                // Then, force UI update for discount section (only if needed)
                debouncedUpdateUI();
                
                console.log('Complete UI update finished');
            } catch (error) {
                console.error('Error in complete UI update:', error);
            }
        }, 100); // Small delay to prevent rapid successive calls
    };
    
    // --- Function to force gift card cleanup ---
    const forceGiftCardCleanup = async () => {
        console.log('Forcing gift card cleanup...');
        await checkAndAddGiftCardForAppliedCoupons();
        console.log('Gift card cleanup completed');
    };
    
    // Make functions globally accessible
    window.forceGiftCardCleanup = forceGiftCardCleanup;
    window.forceCompleteUIUpdate = forceCompleteUIUpdate;

})();
